@if (!tab.showLoader) {
    <div menuSystem [cerrixTab]="tab" class="details" (changeEvent)="handleMenuItemClick($event)">
        <div class="detail-page-action-bar">
            @if (permissions.canEdit) {
                <button class="btn btn-cerrix" (click)="save()">
                    <i class="fas fa-save"></i>
                    <span data-uiid="save" class="d-none d-lg-inline">Save Period</span>
                </button>
            }

            @if (model.id > 0) {
                <span class="date-edited">
                    Last save: {{ model.dateModified | dateTimeFormat }}
                </span>
            }

            <div class="workflow-area">
                @if (!model.dateClosed && permissions.canReopenPeriod) {
                    <button (click)="closePeriod()" class="btn btn-warning">Close period</button>
                }
            </div>
        </div>
        <div class="screens" name="Period" menuicon="far fa-calendar-week" menusystemsubmenu>
            <div
                name="Details"
                menuItemId="universe-period-detail"
                menuicon="fas fa-info-circle"
                menusystemitem
            >
                <audit-universe-period-detail-main
                    [permissions]="permissions"
                    [parentForm]="parentForm"
                    [model]="model"
                >
                </audit-universe-period-detail-main>
            </div>
            @if (permissions.canViewHistory) {
                <div name="History" menuItemId="history" menuicon="fas fa-history" menusystemitem>
                    <app-history-overview
                        [Id]="model.guid"
                        [historyDataService]="_ds"
                        #historyDetailOverviewComponent
                    ></app-history-overview>
                </div>
            }
            @if (permissions.canDelete) {
                <div name="Options" menuicon="fas fa-check-double" menusystemitem>
                    <detail-options
                        moduleName="audit period"
                        [objectName]="model.name"
                        [allowDelete]="true"
                        (onDelete)="delete()"
                    >
                    </detail-options>
                </div>
            }
        </div>
    </div>
}
